import { Modal, Table, Badge, Alert } from "react-bootstrap";
import { useAppSelector } from "../../../../../redux/hooks";
import { ReducerEnum, setClientPortalModalType } from "../../../../../redux/reducer";
import { useContext, useState, useEffect } from "react";
import StateContext from "../../../context/State";
import { ClientInfoModel, ClientPortalRetainerInformation } from "../../../types";
import PortalService from '../../../services/portal.service';


export type ClientRetainerTaskModalProps = {
    dispatch: (arg0: {
        type: ReducerEnum;
        payload: any;
        key?: string;
        extraPayload?: Record<string, string>;
    }) => void;
}

const ClientRetainerTaskModal = (props: ClientRetainerTaskModalProps) => {

    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);

    const show: boolean = useAppSelector((state) => state.ClientPortalState?.ModalType === 'clientretainer');

    const [clients, setClients] = useState<ClientInfoModel[]>([]);
    const [retainerInformation, setRetainerInformation] = useState<boolean>(false);


    // Retrieve Data
    useEffect(() => { 
        const getClientInformation = async () => {
            const clientInfo: ClientInfoModel[] = await portalService.getClientInformation(state.portalId);
            if (clientInfo) { setClients(clientInfo) }
        }
        const getRetainerInformation = async () => {
            const retainerInfo: ClientPortalRetainerInformation = await portalService.getClientPortalRetainerInformation(state.portalId);
            const retainerRequired = (retainerInfo.DefaultRetainerRequired || retainerInfo.TextBoxRetainerRequired || retainerInfo.UploadRetainer);
            retainerRequired ? setRetainerInformation(true) : setRetainerInformation(false)
        }
        getClientInformation(); 
        getRetainerInformation(); 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);
    

    return (
        <>
            <Modal
                show={show}
                onHide={() => { props.dispatch(setClientPortalModalType('')) }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="modal-list"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Client Retainer Status</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {retainerInformation ?
                        (
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Client</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {clients ?
                                        <>
                                            {clients.map((client, index) => (
                                                <tr key={index}>
                                                    <td>{client.Name}</td>
                                                    <td>{client.RetainerAcknowledged ? <Badge bg="success" text="dark" pill>Submitted</Badge> : <Badge bg="secondary" text="dark" pill>Not Submitted</Badge>} </td>
                                                </tr>
                                            )

                                            )}
                                        </>
                                        :
                                        <></>
                                    }
                                </tbody>
                            </Table>
                        )
                        :
                        (
                            <>
                                <Alert style={{margin:"20px"}}>Retainer not Required</Alert>
                            </>
                        )
                    }
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ClientRetainerTaskModal;
